(function () {
  var DESKTOP = '(min-width: 1024px)';

  function norm(s) {
    return (s || '').replace(/[\s ]+/g, ' ').replace(/[:.–—-]+$/, '').trim().toLowerCase();
  }

  function isHeading(el) {
    if (!el || !el.tagName) return false;
    if (/^H[1-6]$/.test(el.tagName)) return true;
    if (el.tagName === 'P') {
      var only = el.children.length === 1 ? el.children[0] : null;
      if (only && (only.tagName === 'STRONG' || only.tagName === 'B') && norm(el.textContent) === norm(only.textContent)) return true;
    }
    return false;
  }

  /* Turn a plain "Key Takeaways" heading + the block under it (written in the
     Shopify blog editor) into the styled callout box. */
  function wrapTakeaways(body, label) {
    if (!body || !label) return;
    if (body.querySelector('.ae__takeaways')) return;

    var target = norm(label);
    var kids = Array.prototype.slice.call(body.children);
    var start = null;

    for (var i = 0; i < kids.length; i++) {
      if (isHeading(kids[i]) && norm(kids[i].textContent) === target) { start = kids[i]; break; }
    }
    if (!start) return;

    var collected = [];
    var node = start.nextElementSibling;
    while (node && !isHeading(node)) {
      collected.push(node);
      node = node.nextElementSibling;
    }
    if (!collected.length) return;

    var box = document.createElement('div');
    box.className = 'ae__takeaways';

    var title = document.createElement('p');
    title.className = 'ae__takeaways-title';
    title.textContent = start.textContent.trim();
    box.appendChild(title);

    body.insertBefore(box, start);
    start.parentNode.removeChild(start);
    collected.forEach(function (el) { box.appendChild(el); });
  }

  function init(root) {
    if (!root || root.dataset.aeReady === '1') return;
    root.dataset.aeReady = '1';

    var tocWrap = root.querySelector('[data-ae-toc]');
    var tocList = root.querySelector('[data-ae-toc-list]');
    var body = root.querySelector('[data-ae-body]');
    var progress = root.querySelector('[data-ae-progress]');
    var entries = [];

    if (body && root.dataset.aeTakeaways) {
      wrapTakeaways(body, root.dataset.aeTakeaways);
    }

    /* ---------- Table of contents ---------- */
    if (tocWrap && tocList && body) {
      var headings = body.querySelectorAll('h2, h3');

      Array.prototype.forEach.call(headings, function (h, i) {
        if (h.closest('.ae__takeaways')) return;
        var text = (h.textContent || '').trim();
        if (!text) return;
        if (!h.id) {
          var slug = text.toLowerCase().replace(/[^a-z0-9\s-]/g, '').trim().replace(/\s+/g, '-').slice(0, 60);
          h.id = slug || 'section-' + i;
        }
        var li = document.createElement('li');
        if (h.tagName === 'H3') li.className = 'is-sub';
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = text;
        li.appendChild(a);
        tocList.appendChild(li);
        entries.push({ heading: h, link: a });
      });

      if (entries.length > 1) {
        tocWrap.hidden = false;

        var mq = window.matchMedia(DESKTOP);
        var syncOpen = function () {
          if (tocWrap.dataset.aeUserToggled === '1') return;
          tocWrap.open = mq.matches;
        };
        syncOpen();
        if (mq.addEventListener) mq.addEventListener('change', syncOpen);
        else if (mq.addListener) mq.addListener(syncOpen);
        tocWrap.addEventListener('toggle', function () {
          if (document.activeElement && tocWrap.contains(document.activeElement)) {
            tocWrap.dataset.aeUserToggled = '1';
          }
        });

        var setActive = function (link) {
          entries.forEach(function (e) {
            if (e.link === link) { e.link.classList.add('is-active'); }
            else { e.link.classList.remove('is-active'); }
          });
        };

        if ('IntersectionObserver' in window) {
          var visible = [];
          var observer = new IntersectionObserver(function (records) {
            records.forEach(function (r) {
              var idx = visible.indexOf(r.target);
              if (r.isIntersecting && idx === -1) visible.push(r.target);
              if (!r.isIntersecting && idx > -1) visible.splice(idx, 1);
            });
            for (var i = 0; i < entries.length; i++) {
              if (visible.indexOf(entries[i].heading) > -1) { setActive(entries[i].link); break; }
            }
          }, { rootMargin: '-90px 0px -70% 0px', threshold: 0 });
          entries.forEach(function (e) { observer.observe(e.heading); });
        }

        tocList.addEventListener('click', function (ev) {
          var a = ev.target.closest ? ev.target.closest('a') : null;
          if (!a) return;
          var target = document.getElementById(decodeURIComponent(a.hash.slice(1)));
          if (!target) return;
          ev.preventDefault();
          window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
          if (history.replaceState) history.replaceState(null, '', a.hash);
          setActive(a);
          if (!window.matchMedia(DESKTOP).matches) tocWrap.open = false;
        });
      }
    }

    /* ---------- Reading progress ---------- */
    if (progress && body) {
      var ticking = false;
      var update = function () {
        ticking = false;
        var rect = body.getBoundingClientRect();
        var total = rect.height - window.innerHeight * 0.4;
        var done = -rect.top + window.innerHeight * 0.35;
        var pct = total > 0 ? (done / total) * 100 : 0;
        if (pct < 0) pct = 0;
        if (pct > 100) pct = 100;
        progress.style.width = pct.toFixed(1) + '%';
      };
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }

    /* ---------- Copy link ---------- */
    Array.prototype.forEach.call(root.querySelectorAll('[data-ae-copy]'), function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-ae-copy');
        var done = function () {
          var wrap = btn.closest('.ae__share') || btn.parentNode;
          var flag = wrap ? wrap.querySelector('[data-ae-copied]') : null;
          if (flag) {
            flag.hidden = false;
            setTimeout(function () { flag.hidden = true; }, 2000);
          }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () {});
        } else {
          var tmp = document.createElement('input');
          tmp.value = url;
          document.body.appendChild(tmp);
          tmp.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          document.body.removeChild(tmp);
        }
      });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.article-editorial'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('.article-editorial') : null;
    if (el) { el.dataset.aeReady = ''; init(el); }
  });
})();
